import Base from './Base';
import Helper from '../Helper';
import Product from '../../Stores/Product';
import WidgetsInput from '../../Components/Widgets/Input.svelte';
import {get} from 'svelte/store';

export default class Input extends Base {
	build(list, property, active) {
		const selected = property.selected || {};
		const mapping = {vast: 'select', infomore: 'more', more: 'more'};
		const type = mapping[property.type] || 'more';
		const [options, min, max] = this.options(property);

		const range = `Minimaal ${min} ${property.unit}, maximaal ${max} ${property.unit}`;
		const warning = ((type === 'more') && (min || max)) ? range : '';
		const notice = ((type === 'select') && (min || max)) ? range : '';

		const host = this;
		const state = !Helper.undefined(selected.value) ? (selected.valid ? 'success' : 'error') : '';
		const component = {
			component: WidgetsInput,
			config: {
				active, type, options, warning, notice, state,
				value: selected.value || null,
				label: property.name,
				unit: property.unit,
				required: !!property.required,
				description: property.description,
				on_change: item => {
					item = host.moreItem(item, property, type);
					Product.setProperty(property);
					property.selected = item;

					const wait = !!property.group;
					this.update(wait);
				}
			}
		};

		if (type === 'more') {
			component.config.minimum = min;
			component.config.maximum = max;
		}

		list.push(component);
		return list;
	}

	options(property) {
		let min = Number.MAX_SAFE_INTEGER;
		let max = 0;
		let valid = false;
		const options = [];
		if (Array.isArray(property.values))
			for (let value of property.values)
				if (this.validOption(property, value)) {
					valid = true;
					const number = parseInt(value.value);
					if (!isNaN(number)) {
						if (number < min) min = number;
						else if (number > max) max = number;
					}

					options.push({value: value.id, label: value.value});
				}

		if (!valid) min = max = 0;
		return [options, min, max];
	}

	moreItem(item, property, type) {
		if (type === 'more') {
			let nearest = {id: 0, value: Number.MAX_SAFE_INTEGER};
			const variations = get(Product).variations;
			for (let variation of variations)
				for (let option of variation.options)
					if (option.option_id == property.option_id) {
						const value_more = option.value >= item.value;
						const nearest_less = option.value <= nearest.value;
						if (value_more && nearest_less)
							nearest = {id: option.value_id, value: option.value};
					}

			if (nearest.id)
				item.option_value_id = nearest.id;
		}

		return item;
	}

	validOption(property, value) {
		const valid_variation = variation => {
			for (let option of variation.options)
				if (option.option_id == property.option_id)
					return value.id == option.value_id;
		};

		const product = get(Product);
		const valid_option = option => {
			let valid = true;
			steps:
				for (let step of product.steps)
					for (let item of step.properties)
						if (item != property)
							if (item.option_id === option.option_id) {
								const optioned = !!item.selected.option_value_id;
								const option_key = optioned ? 'option_value_id' : 'value';
								const match = item.selected[option_key];
								if (match) {
									valid = match === option.value_id;
									if (!valid) break steps;
								}
					}

			return valid;
		};

		let matched = false;
		let valid = ['infomore'].includes(property.type);
		if (!valid)
			for (let variation of product.variations)
				if (valid_variation(variation)) {
					matched = true;
					let current = true;
					for (let option of variation.options)
						if (!valid_option(option))
							current = false;

					if (current)
						{ valid = true; break; }
				}

		if (!matched) valid = true;
		return valid;
	}
}